import React, { useState } from "react";
import "./Home.css";
import BackgroundImage from "../../assets/images/HomeImage.webp";
import { strings } from "../../translations/strings";
import IdeaValidatorIcon from "../../assets/icons/IdeaValidator.svg";
import MarketInsights from "../../assets/icons/MarketInsights.svg";
import PitchDeckAnalyzerIcon from "../../assets/icons/PitchDeckAnalyzer.svg";
import ArrowIcon from "../../assets/icons/RightArrowGrey.svg";
import Disclaimer from "../../common/Disclaimer";

const Home = ({ data }) => {
  const { colors, changeScreen, SCREENS, isDarkMode, navigateToRoute } = data;
  const items = [
    {
      image: IdeaValidatorIcon,
      title: strings.idea_validator_tab,
      screen: SCREENS.IDEA_VALIDATOR,
    },
    {
      image: MarketInsights,
      title: strings.market_insights_tab,
      screen: SCREENS.MARKET_INSIGHTS,
    },
    {
      image: PitchDeckAnalyzerIcon,
      title: strings.pitch_deck_analyzer_tab,
      screen: SCREENS.PITCH_DECK_ANALYZER,
    },
  ];
  const [showArrowIndex, setShowArrowIndex] = useState(null);

  return (
    <div className="home-container">
      <img
        alt="Background"
        src={BackgroundImage}
        className="home-background-image"
        draggable={false}
      />
      <div
        className="home-hairline"
        style={{ backgroundColor: colors.borderColor }}
      />
      <div
        className="home-content"
        style={{ backgroundColor: colors.componentBackground }}
      >
        <span className="home-title" style={{ color: colors.primaryText }}>
          {strings.home_title}
        </span>
        <span className="home-text" style={{ color: colors.secondaryText }}>
          {strings.home_text}
        </span>
        <div className="home-disclaimer-container">
          <Disclaimer colors={colors} />
        </div>
        <span className="home-select-text" style={{ color: colors.tabText }}>
          {strings.home_select_tool}
        </span>
        {items?.map((item, index) => {
          return (
            <div
              key={`${index}`}
              className="home-item-container"
              onClick={() => changeScreen(item?.screen)}
              style={{ borderColor: colors.borderColor }}
              onMouseEnter={(e) => {
                e.target.style.boxShadow = `0px 16px 16px -4px rgba(0, 0, 0, ${
                  isDarkMode ? 0.5 : 0.1
                })`;
                setShowArrowIndex(index);
              }}
              onMouseLeave={(e) => {
                e.target.style.boxShadow = "none";
                setShowArrowIndex(null);
              }}
            >
              <div className="home-item-image-and-title">
                <img
                  alt={item?.title}
                  src={item?.image}
                  draggable={false}
                  className="home-item-image"
                />
                <span
                  style={{ color: colors.homeTabText }}
                  className="home-item-title"
                >
                  {item?.title}
                </span>
              </div>
              {index === showArrowIndex && (
                <img
                  className="home-item-arrow"
                  alt="Arrow"
                  src={ArrowIcon}
                  draggable={false}
                />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default Home;
